module.exports = __webpack_public_path__ + "img/horizontal_3_4_9016.458a62c6.png";